import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import { selectTreatmentPlan } from '../../../../treatment/state/plan/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import {IPR_NOT_REQUIRED, IS_IPR_INSTRUCTIONS_LIST_SAVED} from '../../../../treatment/state/plan/const'
import { selectStoreList } from '../../../../globals/state/selector'
import { selectCustomer } from "../../../../customer/state/detail/selector";

export default {
    taskName: taskName.CREATE_TREATMENT_PLAN,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                isIprReadOnly: false,
            },
        },
        {
            component: processUI.IPR_INSTRUCTIONS_WIDGET,
        },
        {
            component: processUI.PATIENT_IPR_WISHES_WIDGET,
            widgetProps: {
                readOnly: true,
            },
        },
        {
            component: processUI.ATTACHMENT_NEEDED_WIDGET,
            readOnly: false,
        },
        {
            component: processUI.ATTACHMENT_AGREEMENT_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_CLASSIFICATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        },
    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
        selectTreatmentPlan,
        selectStoreList,
        selectCustomer,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context, treatmentPlan, stores, customer) => {
        const messageList = []

        const { treatmentType, treatmentReason, attachmentNeeded } = treatmentPlan;

        if (treatmentType === null) {
            messageList.push(
                createValidationMessage(
                    'Treatment Type is mandatory field for Medical/Non Medical Treatment Classification.',
                    'treatmentPlan.treatmentType'
                )
            )
        }



        if (treatmentType === 'medical' && treatmentReason === null) {
            messageList.push(
                createValidationMessage(
                    'Treatment Reason is mandatory field for Medical Treatment.',
                    'treatmentPlan.treatmentReason'
                )
            )
        }

        if (eventName === 'cannot_be_treated') {
            const cannotBeTreatedReason = context.cannotBeTreatedReason
            if (!cannotBeTreatedReason) {
                messageList.push(createValidationMessage(
                    "Please add the reason for 'cannot be treated' before proceeding.",
                    'checkDeliveryTracking.checkDeliveryTracking'
                ))
            }
            return messageList
        }

        if (eventName === 'plan_done') {
            const { numberOfAlignerLowerJaw, numberOfAlignerUpperJaw, treatmentDuration, iprInstructionList } = treatmentPlan

            const isZeroOrEmpty = value => !Number(value)
            const iprAdjustmentValues = Object.values(iprInstructionList || {})
            const IPRInstructionsMissing = iprAdjustmentValues.every(isZeroOrEmpty)
            const IPRDecided = context[IPR_NOT_REQUIRED] !== undefined
            const IPRNotNeeded = context[IPR_NOT_REQUIRED];

            const store = stores.find(s => s.technicalName === customer.store);
            const isIPRProviderStore = store.iprProvider;
            const isAttachmentProviderStore = store.attachmentAvailable;

            if (attachmentNeeded === null && isAttachmentProviderStore) {
                messageList.push(
                    createValidationMessage(
                        'Please select if attachment is needed',
                        'treatmentPlan.attachmentNeeded'
                    )
                )
            }

            if (!numberOfAlignerLowerJaw && numberOfAlignerLowerJaw !== 0) {
                messageList.push(createValidationMessage(
                    'Please add number of aligner lower jaw.',
                    'treatmentplan.numberOfAlignerLowerJaw'
                ))
            }

            if (!numberOfAlignerUpperJaw && numberOfAlignerUpperJaw !== 0) {
                messageList.push(createValidationMessage(
                    'Please add number of aligner upper jaw.',
                    'treatmentplan.numberOfAlignerUpperJaw'
                ))
            }

            if (!treatmentDuration) {
                messageList.push(createValidationMessage(
                    'Treatment duration has not been calculated',
                    'treatmentplan.treatmentDuration'
                ))
            }

            // fixme: this validation rules should be composed on a higher level
            if (isIPRProviderStore) {
                if (!IPRDecided) {
                    messageList.push(createValidationMessage(
                        'Please decide whether IPR is needed.',
                        'treatmentplan.iprInstructions'
                    ))
                } else if ((!IPRNotNeeded && IPRInstructionsMissing) || !context.hasOwnProperty(IS_IPR_INSTRUCTIONS_LIST_SAVED)) {
                    messageList.push(createValidationMessage(
                        'Please fill in the IPR requirements.',
                        'treatmentplan.iprInstructions'
                    ))
                }
            }
        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/create-treatment-plan.js